if (!customElements.get('theme-footer')) {
 class ThemeFooter extends HTMLElement {
  connectedCallback() {
   this.onClick = event => {
    const button = event.target.closest('.dc-footer-toggle');
    if (!button || !this.contains(button)) return;
    const opening = button.getAttribute('aria-expanded') !== 'true';
    this.querySelectorAll('.dc-footer-toggle').forEach(toggle => {
     const open = toggle === button && opening;
     toggle.setAttribute('aria-expanded', String(open));
     toggle.parentElement.querySelector('.thb-widget-menu').hidden = !open;
    });
   };
   this.addEventListener('click', this.onClick);
  }
  disconnectedCallback() { this.removeEventListener('click', this.onClick); }
 }
 customElements.define('theme-footer', ThemeFooter);
}
